/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
//actions
import { resetForm } from '@insticator/insticator-ui';
import { setFormEditableState, discardChanges } from '@insticator/insticator-ui';
import { updatePageDetails, changePage } from '@insticator/insticator-ui';
import { savePaymentInformationWithValidation, getPaymentInformation, changePaymentType } from 'state/actions/accountState/account_data';
// component
import ExistingPayments from 'pages/dashboard/account/paymentinfo/existingpayments/existingpayments';



/* ========== ~~~~~~~~~~ ACCOUNT EXISTING PAYMENTS : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ accountData, sessionStatus }) => ({
    selectedPaymentType: accountData.selectedPaymentType,
    savedPaymentTypes: accountData.savedPaymentTypes,
    paymentInfo: accountData.paymentInfo,
    payoutThreshold: accountData.payoutThreshold,
    accountUUID: sessionStatus.accountUUID,
    mocked: sessionStatus.mocked
});

// map actions
const mapDispatchToProps = dispatch => ({
    resetForm: formName => dispatch(resetForm(formName)),
    setFormEditableState: (formName, isEditable) => dispatch(setFormEditableState(formName, isEditable)),
    discardChanges: (formName) => dispatch(discardChanges(formName)),
    savePaymentInformationWithValidation: ( data, paymentType, fields, accountUUID ) => dispatch(savePaymentInformationWithValidation(fields, data, paymentType, accountUUID)),
    getPaymentInformation: (accountUUID) => dispatch(getPaymentInformation(accountUUID)),
    changePaymentType: (paymentType, paymentUUID) => dispatch(changePaymentType(paymentType, paymentUUID)),
    moveToPage: (location) => {
        dispatch(updatePageDetails(location));
        dispatch(changePage(location))
    }
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExistingPayments);
